import React from "react";
import NavbarSection from "../Navbar";
import HeroSection from "../HeroSection";
import AboutUs from "../AboutUs";
import BoardMembers from "../BoardMembers";
import Service from "../Service";
import CurrentJobs from "../CurrentJobs";
import Chapters from "../Chapters";
import Events from "../Events";
import GetInTouch from "../GetInTouch";
import Footer2 from "../Footer2";
import Benefitscard from "../Benefitscards";
import Blockprofilelanding from "../Blockprofilelanding";







function LandingPage(){
    return(
        <>

        <NavbarSection/>
        <HeroSection/>
        <AboutUs/>
        <BoardMembers/>
        <Service/>
        <CurrentJobs/>
        <Chapters/>
        <Events/>
        <Benefitscard/>
        <Blockprofilelanding/>
        <GetInTouch/>
        <Footer2/>
        
        
        
        </>
    )
}
export default LandingPage;